import React          from 'react';
import eggLogo1       from '../../images/eggLogo1.png';
import eggLogo2       from '../../images/eggLogo2.jpg';
import { makeStyles } from '@material-ui/core/styles';

var clsx = require('classnames')

const useStyles = makeStyles(() => ({
    root: {
        minHeight:       '100vh',
        minWidth:        '100vw',
        maxHeight:       '100vh',
        maxWidth:        '100vw',
        backgroundColor: '#FFF',
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'space-evenly',
        flexFlow:        'column',
        overflow:        'hidden',
        transition:      'opacity 0.8s',
    },
    row1: {
        minHeight:       '50vh',
        minWidth:        '100vw',
        maxHeight:       '50vh',
        maxWidth:        '100vw',
        backgroundColor: '#FFF',
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'space-evenly',
    },
    row2: {
        minHeight:       '50vh',
        minWidth:        '100vw',
        maxHeight:       '50vh',
        maxWidth:        '100vw',
        backgroundColor: '#FFF',
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'space-evenly',
    },
    item: {
        flex:           1,
        display:        'flex',
        alignItems:     'center',
        justifyContent: 'center',
        textAlign:      'center',
        width:          '100%',
        height:         '50vh',
    },
    bigItem: {
        flex:           1,
        display:        'flex',
        alignItems:     'center',
        justifyContent: 'center',
        textAlign:      'center',
        width:          '100%',
        height:         '50vh',

    },
    smallItem: {
        flex:           0.3,
        flexFlow:       'column',
        justifyContent: 'flex-start',

    },
    title: {
       flexFlow: 'column',

    },
    bigFont: {
        fontSize:   38,
        fontWeight: 'bold'
    },
    smallFont: {
        fontSize: 34,
    },
    icon: {
        backgroundSize:     'contain',
        backgroundPosition: 'center',
        backgroundRepeat:   'no-repeat',
    },
    icon1: {
        width:           '90%',
        height:          '90%',
        backgroundImage: `url(${ eggLogo1 })`,
    },
    icon2: {
        width:           '90%',
        height:          '90%',
        backgroundImage: `url(${ eggLogo2 })`,
    },
    pageIcon: {
        width:  '100%',
        height: '50%',
    },
    inner: {
        width:          '90%',
        height:         '90%',
        display:        'flex',
        flexFlow:       'column',
        alignItems:     'center',
        justifyContent: 'center',
        textAlign:      'center',
        border:         '1px solid #DDD',
        borderRadius:   '1em',
        cursor:         'pointer',
        fontSize:       25,
        '&:hover': {
            backgroundColor: '#EEF'
        }
    },
    name: {
        width:          '90%',
        height:         '30%',
        display:        'flex',
        flexFlow:       'column',
        alignItems:     'center',
        justifyContent: 'center',
        textAlign:      'center',
    },
    smalltext: {
       fontSize: 18
    }
}))

type MenuProps = {
    pages:          { name: string, icon: string }[];
    wideScreen:     boolean;
    handleNavigate: (val: string) => void;
}

const Menu: React.FC<MenuProps> = ({ pages, wideScreen, handleNavigate }) => {

  const classes = useStyles();

  return (
     <div className = { classes.root }>
        <div className = { classes.row1 }> 
           <div className = { clsx(classes.item, classes.smallItem) }> 
              <div className = { clsx(classes.icon, classes.icon1) }/>
           </div>
           <div 
              dir       = 'rtl'
              className = { clsx(classes.item, classes.bigItem, classes.title) }
           > 
              <div className  =  { classes.bigFont }>חיבור בתחום העשרים</div>
              <div className = { classes.smallFont }>תבניות הביצים</div>
           </div>
           <div className = { clsx(classes.item, classes.smallItem) }> 
              <div className = { clsx(classes.icon, classes.icon2) }/>  
           </div>
        </div>
        <div className = { classes.row2 }>
        {
            pages.map((val, ind) => {
                return (
                    <div
                      key       = { `page_:^^${ ind }` }
                      className = { classes.bigItem }
                      style     = {{
                        fontSize: wideScreen ? 24 : 18,
                      }}
                    >
                        <div 
                           className = { classes.inner }
                           onClick   = { () => { handleNavigate(val.name) }}
                        >
                           
                           <div className = { wideScreen ? classes.name : clsx(classes.name, classes.smalltext) }>
                             { 
                                (ind === 1 || ind === 2)
                                &&
                                <div dir = 'rtl'>
                                    { `חיבור:` }
                                </div>
                             } 
                             <div dir = 'rtl'>
                                    { val.name }
                             </div>
                           </div>
                           <div
                              className = { clsx(classes.icon, classes.pageIcon) }
                              style     = {{
                                  backgroundImage: `url(${ val.icon })`
                              }}
                           />
                        </div>
                    </div>
                )
            })
        }
        </div>
     </div>
  );
}



export default Menu;


